import React from 'react'

const SavedIcon = () => {
  return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8473 3.32516C16.5387 5.24499 16.3463 8.16611 14.4174 9.84966L9.73706 13.9348C8.56156 14.9608 6.79584 14.9145 5.67578 13.8282L1.40346 9.68492C-0.433981 7.90296 -0.472174 4.97582 1.31816 3.14696C3.10849 1.31811 6.04938 1.28009 7.88683 3.06205L7.98942 3.16155L8.29215 2.89732C10.221 1.21377 13.1558 1.40532 14.8473 3.32516Z" fill="currentColor"></path></svg>


}

export default SavedIcon
